import { CommonModule } from '@angular/common';
import { Component, NgModule, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'card-auth',
    templateUrl: './card-auth.component.html',
    styleUrls: ['./card-auth.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CardAuthComponent {
  @Input()
  title!: string;

  @Input()
  description!: string;
}

@NgModule({
  imports: [CommonModule],
  declarations: [CardAuthComponent],
  exports: [CardAuthComponent],
})
export class CardAuthModule {}
